export default {
  language_selector: {
    label: 'Kies een taal',
  },
  nav_items: {
    home: 'Home',
    menu: 'Menu',
    locations: 'Locaties',
    store_info: 'Winkelinfo',
    rewards: 'Beloningen',
  },
};
